import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import { PresupuestoProvider } from './context/PresupuestoContext';
import './index.css';

const rootElement = document.getElementById('root');

createRoot(rootElement).render(
  <StrictMode>
    <PresupuestoProvider>
      <App />
    </PresupuestoProvider>
  </StrictMode>
);
